module.exports = __webpack_public_path__ + "img/Best Sellers Ranking.0fc906e9.svg";